import React, { useEffect, lazy, Suspense } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ScreedAdvantage } from "@/components/ScreedAdvantage";
import { WhatWeDo } from "@/components/WhatWeDo";
import { PourProcess } from "@/components/PourProcess";
import { ServiceAreas } from "@/components/ServiceAreas";
import { ContactAndMap } from "@/components/ContactAndMap";
import { Footer } from "@/components/Footer";

// Lazy-load below-the-fold heavy sections so their assets (base64 project
// images in the conveyor, the review-widget iframe in Testimonials) are
// fetched in separate chunks after first paint instead of bloating the
// initial JS bundle.
const ProjectsConveyor = lazy(() =>
  import("@/components/ProjectsConveyor").then((m) => ({
    default: m.ProjectsConveyor,
  })),
);
const Testimonials = lazy(() =>
  import("@/components/Testimonials").then((m) => ({
    default: m.Testimonials,
  })),
);

const Index: React.FC = () => {
  useEffect(() => {
    const existing = document.getElementById("home-faq-jsonld");
    if (existing) existing.remove();
    const faqJsonLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is liquid screed and how is it different from traditional screed?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Liquid screed is a free-flowing, self-levelling floor screed that is pumped into place rather than trowelled by hand. It wraps completely around underfloor heating pipes with no air gaps, dries faster, and gives a much flatter finish than traditional sand and cement screed.",
          },
        },
        {
          "@type": "Question",
          name: "How long does liquid screed take to dry in Exeter?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can walk on Cemfloor liquid screed within 24 to 48 hours of pouring. It is typically ready for final floor coverings in 10 to 14 days for fast-drying mixes, compared to 60 to 90 days for traditional screed.",
          },
        },
        {
          "@type": "Question",
          name: "Do you offer a guarantee on liquid screed installations?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, all Cemfloor liquid screed installations come with a 10-year Cemfloor product guarantee on materials. We are Cemfloor approved and certified installers serving Exeter, Devon, Somerset and the wider South West.",
          },
        },
        {
          "@type": "Question",
          name: "What areas do Exeter Flow Screeds cover?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We cover Exeter, Exmouth, Newton Abbot, Torquay, Tiverton, Honiton, Taunton, Topsham, Plymouth, Barnstaple, Bath, Bournemouth and the wider Devon, Somerset and Dorset region.",
          },
        },
        {
          "@type": "Question",
          name: "How much does liquid screed cost in Devon?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Pricing depends on the area size, screed depth and the specific Cemfloor product needed. We offer free, fixed-price quotes with no obligation. Contact us on 07765 712609 or 07470 861869 for a same-day quote.",
          },
        },
      ],
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "home-faq-jsonld";
    script.text = JSON.stringify(faqJsonLd);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById("home-faq-jsonld");
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F5] text-stone-900 selection:bg-amber-200 selection:text-amber-900 font-sans">
      <Navbar />
      <main>
        <Hero />
        <ScreedAdvantage />
        <Suspense fallback={null}>
          <ProjectsConveyor />
        </Suspense>
        <WhatWeDo />
        <Suspense fallback={null}>
          <Testimonials />
        </Suspense>
        <PourProcess />
        <ServiceAreas />
        <ContactAndMap />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
